import ActivityLogsModal from "@components/ActivityLogsModalPlugin/ActivityLogsModal.vue";
import { nextTick, ref } from "vue";

export interface ActivityLogsPlugin {
    show(type: string, uuid: string): void,
}

const activityLogsModal = {
    install: (app: any) => {
        let activityLogSubjectType = ref<string | null>(null);
        let activityLogSubjectUuid = ref<string | null>(null);

        const activityLogs: ActivityLogsPlugin = {
            show: (type: string, uuid: string): void => {
                // Force the watcher to trigger
                activityLogSubjectType.value = type;
                nextTick(() => {
                    activityLogSubjectType.value = type;
                });
                activityLogSubjectUuid.value = uuid;
            }
        };

        app.provide("activityLogSubjectType", activityLogSubjectType);
        app.provide("activityLogs", activityLogs);
        app.provide("activityLogSubjectUuid", activityLogSubjectUuid);
        app.component("activity-logs-modal", ActivityLogsModal);
    },
};
export default activityLogsModal;
